import { useState } from "react";
import { useCampaigns } from "./campaigns/useCampaigns";
import { CampaignCreate } from "./campaigns/CampaignCreate";
import { CampaignList } from "./campaigns/CampaignList";
import { CampaignDetail } from "./campaigns/CampaignDetail";

const CampaignsView = ({ userId }) => {
  const [showCreate, setShowCreate] = useState(false);
  const cx = useCampaigns(userId);

  const openCreate = () => {
    cx.fetchTemplates();
    setShowCreate(true);
  };

  const closeOnSuccess = (create) => async (payload) => {
    const ok = await create(payload);
    if (ok) setShowCreate(false);
    return ok;
  };

  if (showCreate) {
    return (
      <CampaignCreate
        userId={userId}
        templates={cx.templates}
        onBack={() => setShowCreate(false)}
        onCreateCSV={closeOnSuccess(cx.createFromCSV)}
        onCreateLeads={closeOnSuccess(cx.createFromLeads)}
        onDeleteTemplate={cx.deleteTemplate}
      />
    );
  }

  if (!cx.selectedCampaign) {
    return <CampaignList campaigns={cx.campaigns} loading={cx.loading} onOpen={cx.openCampaign} onCreate={openCreate} />;
  }

  return (
    <CampaignDetail
      userId={userId}
      detail={cx.campaignDetail}
      loading={cx.detailLoading}
      onBack={cx.closeCampaign}
      onDelete={cx.deleteCampaign}
      onSaveTemplate={cx.saveTemplate}
      onApprove={cx.approveEmail}
      onSkip={cx.skipProspect}
    />
  );
};

export default CampaignsView;
